import { Extension } from "@tiptap/core";

declare module "@knowt/editor/core" {
    interface Commands<ReturnType> {
        dragHandleListener: {
            setDragHandleActive: (isActive: boolean) => ReturnType;
            getDragHandleActive: () => ReturnType;
        };
    }
}

/**
 * This extension is used to track `DragHandle` plugin's state
 * so that it can be used for "utils/isCustomNodeSelected.ts" to detect either the toolbar should be shown or not.
 * otherwise, the toolbar will be shown during ContentItemMenu's Grip is being draggged
 */
export const DragHandleListener = Extension.create({
    name: "dragHandleListener",

    addOptions() {
        return {
            isActive: false,
        };
    },

    addCommands() {
        return {
            setDragHandleActive:
                (isActive: boolean) =>
                ({ editor: _ }) => {
                    this.options.isActive = isActive;
                    return true;
                },
            getDragHandleActive: () => () => {
                return this.options.isActive;
            },
        };
    },
});

export default DragHandleListener;
